export enum THEMES {
  LIGHT = 'light-theme',
  DARK = 'dark-theme',
  NIGHT_VISION = 'night-vision-theme',
}

export enum STORE_CONSTANTS {
  THEME = 'THEME',
  USER = 'USER',
  MOCK_API_USERS = 'MOCK_API_USERS',
  MOCK_API_TOKENS = 'MOCK_API_TOKENS',
  NEXT_ID = 'NEXT_ID',
}
